export enum WorkflowAction {
  REQUEST_STARTED = "WORKFLOW_REQUEST_STARTED",
  REQUEST_SUCCESS = "WORKFLOW_REQUEST_SUCCESS",
  REQUEST_FAILURE = "WORKFLOW_REQUEST_FAILURE",
}
